export function storeItem(key, item) {
    sessionStorage.setItem(key, JSON.stringify(item));
};

export function getValueFromSessionStored(key, default_value = null) {
    return JSON.parse(sessionStorage.getItem(key, default_value));
};

export function messagesStored() {
    if (getValueFromSessionStored("appState")) {
        return getValueFromSessionStored("appState").messages;
    }
    return []
};